<template>
  <div class="promo_slider">
    <client-only>
      <swiper :options="sliderOptions">
        <swiper-slide v-for="(val, i) in itemsList" :key="`promoslider-${ i }`">
          <CardPromo
            :img="val.image"
            :title="val.name"
            :imgBgrColor="val.imgBgrColor"
            @click="$router.push(`/promos/${ val.id }`)"
          />
        </swiper-slide>
      </swiper>
      <div id="promoSlider" slot="pagination" class="swiper-pagination" />
    </client-only>
  </div>
</template>

<script>
import CardPromo from '@/components/page/CardPromo'
import _ from 'lodash'

export default {
  components: { CardPromo },
  props: {
    items: {
      type: Array,
      default () {
        return []
      },
    },
    currentId: {
      type: Number,
      default () {
        return 0
      },
    },
    sliderOptions: {
      type: Object,
      default () {
        return {
          slidesPerView: 2,
          spaceBetween: 30,
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            0: {
              slidesPerView: 1,
            },
          },
        }
      },
    },
  },
  computed: {
    itemsList () {
      if (this.currentId > 0) {
        return _.reject(this.items, (element) => {
          return element.id === this.currentId
        })
      }

      return this.items
    },
  },
}
</script>

<style lang="less">
.promo_slider {
	.swiper {
		&-container {
			padding-bottom: 40px;
		}

		&-pagination {
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);

			&-bullet {
				width: 13px;
				height: 7px;
				background-color: #DEDEDE;
				border-radius: 20px;

				&:not(:last-child) {
					margin-right: 7px;
				}

				&-active {
					width: 28px;
					background-color: #003CFF;
				}
			}
		}
	}
}
</style>
